import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';

import { IAppRootState } from '../../core/store';
import { MetadataListEntity } from '../components/metadata-list/metadata-list.entity';
import { MetadataState, MetadataFeatureKey } from './metadata.state';

interface MetadataRootState extends IAppRootState {
	[MetadataFeatureKey]: MetadataState;
}

@Injectable()
export class MetadataSelector {
	public constructor(private readonly store: Store<MetadataRootState>) {}

	private get state(): Observable<MetadataState> {
		return this.store.pipe(select((store) => store[MetadataFeatureKey]));
	}
	public getLoading$(): Observable<boolean> {
		return this.state.pipe(map((state) => state.get('loading')));
	}

	public getMetadataList$(): Observable<MetadataListEntity> {
		return this.state.pipe(map((state) => state.get('metadataList')));
	}
}
